import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
//components
import App from "../app.jsx";
// login
import Logs from "../pages/Logs/Logs.jsx";
import Login from "../pages/Login/Login.jsx";
import Teams from "../pages/Teams/Teams.jsx";
import SendDocument from "../pages/Login/SendDocument.jsx";
import Dashboard from "../pages/Dashboard/Dashboard.jsx";
import Pendencies from "../pages/Pendencies/Pendencies.jsx";
import GeneralRegistration from "../pages/GeneralRegistration/index.jsx";
import SalesManagement from "../pages/SalesManagement/SalesManagement.jsx";
import UserRegistration from "../pages/UserRegistration/UserRegistration.jsx";
import Negotiations from "../pages/SalesManagement/Enterprise/Negotiations/Negotiations.jsx";
import Proposal from "../pages/SalesManagement/Enterprise/Negotiations/Proposals/Proposal/Proposal.jsx";
import EnterpriseDetails from "../pages/SalesManagement/EnterpriseSettings/EnterpriseDetails/EnterpriseDetails.jsx";
// context
import { RequiredProvider } from "../pages/GeneralRegistration/Context.js";
import { SimuladorProvider } from "../pages/SalesManagement/Enterprise/Simulator/SimulatorContext.jsx";
// error pages
import Error404 from "../pages/ErrorPage/Error404.jsx";
import Error403 from "../pages/ErrorPage/Error403.jsx";
import Error500 from "../pages/ErrorPage/Error500.jsx";
// validade
import { getStatusAccount, isAuthenticated } from "../utils/auth.js";
// routes
import { BanksRoute } from "./banks.jsx";
import { WalletRoute } from "./wallet.jsx";
import { ModuleRoute } from "./modules.jsx";
import { ReportsRoute } from "./reports.jsx";
import { SettingsRoute } from "./settings.jsx";
import { FinancialRoute } from "./financial.jsx";
import { TrainingsRoute } from "./trainings.jsx";
import { EnterpriseRoutes } from "./enterprise.jsx";
import { NotificationsRoute } from "./notifications.jsx";
import { EnterpriseSettingsRoute } from "./enterpriseSettings.jsx";
import WhatsAppQRCode from "../pages/SalesManagement/EnterpriseSettings/WhatsappConfig/WhatsappConfig.jsx";
import EmailConfig from "../pages/SalesManagement/EnterpriseSettings/Emails/EmailConfig.jsx";
import CreateAccount from "../pages/CreateAccount/CreateAccount.jsx";
import ClickSignConfig from "../pages/SalesManagement/EnterpriseSettings/ClickSign/ClickSignConfig.jsx";
import MyAccount from "../pages/MyAccount/MyAccount.jsx";
import NewPassword from "../pages/Login/NewPassword.jsx";
import { Simulation } from "../pages/SalesManagement/Enterprise/Negotiations/Simulations/Simulation/Simulation.jsx";
import RegisterCompleted from "../pages/CreateAccount/RegisterCompleted/RegisterCompleted.jsx";
import { CreateAccountProvider } from "../context/CreateAccountContext.jsx";
import ClickSignRegistrations from "../pages/Settings/ClickSignIntegration/ClickSignRegistrations.jsx";
import SendingEmails from "../pages/Settings/SendingEmails/SendingEmails.jsx";
import PublicMap from "../pages/Public/Map.jsx";
import { MapProvider } from "../context/MapContext.jsx";
import PublicGoogleMap from "../pages/Public/GoogleMaps.jsx";
import Simulator from "../pages/SalesManagement/Enterprise/Simulator/Simulator.jsx";
import { LaunchCommission } from "../pages/Commission/LaunchCommission.jsx";
import { UserRegistrationProvider } from "../pages/UserRegistration/UserRegistrationContext.jsx";
import { RegisterCompletedProvider } from "../pages/CreateAccount/RegisterCompleted/RegisterCompletedContext.jsx";
import VerifyEmail from "../pages/Login/VerifyEmail.jsx";
import { LaunchCommissionSale } from "../pages/Commission/LaunchCommissionSale.jsx";
import { CrmRoute } from "./crm.jsx";
import SalesMirror from "../pages/SalesManagement/Enterprise/SalesMirror/SalesMirror.jsx";
import Register from "../pages/SalesManagement/EnterpriseSettings/Register/Register.jsx";
import AIroutes from "./ai.jsx";
import Connections from "../pages/Connections/Connections.jsx";
import { FiltersProvider } from "../context/FiltersContext.jsx";

import TemplateRoute from "../pages/SalesManagement/EnterpriseSettings/WebSite/Routes/TemplateRoute.jsx";
import FeasibilityStudy from "../pages/SalesManagement/EnterpriseSettings/FeasibilityStudy/FeasibilityStudy.jsx";

function Router() {
  const PrivateRoute = ({ children }) => {
    const auth = isAuthenticated();
    const statusAccount = getStatusAccount();
    return auth && statusAccount ? children : <Navigate to="/" />;
  };

  return (
    <BrowserRouter>
      <SimuladorProvider>
        <Routes>
          <Route path="/" element={<App />}>
            <Route index element={<SendDocument />} />
            <Route path="/login" element={<SendDocument />} />
            <Route
              path="/createAccount"
              element={
                <CreateAccountProvider>
                  <CreateAccount />
                </CreateAccountProvider>
              }
            />
            <Route
              path="/success"
              element={
                <RegisterCompletedProvider>
                  <RegisterCompleted />
                </RegisterCompletedProvider>
              }
            />
            <Route path="/error" element={<Error500 />} />
            <Route path="/403" element={<Error403 />} />
            <Route path="/404" element={<Error404 />} />
            <Route path="/500" element={<Error500 />} />
            <Route path="/login/:id" element={<Login />} />
            <Route path="/verify" element={<VerifyEmail />} />
            <Route
              path="/publicMap/:hash/:userId?/:role?/:token?/:appProfData?/:enterpriseId?"
              element={
                <MapProvider>
                  <PublicMap />
                </MapProvider>
              }
            />
            <Route
              path="/publicSimulator/:hash/:id/:userId?/:role?/:token?/:appProfData?/:enterpriseId?"
              element={
                <SimuladorProvider>
                  <RequiredProvider>
                    <Simulator />
                  </RequiredProvider>
                </SimuladorProvider>
              }
            />{" "}
            {/* id ==> land id */}
            <Route
              path="/publicGoogleMaps/:hash"
              element={
                <MapProvider>
                  <PublicGoogleMap />
                </MapProvider>
              }
            />
            <Route path="trainings/*" element={<TrainingsRoute />} />
            <Route
              path="dashboard"
              element={
                <PrivateRoute>
                  {" "}
                  <Dashboard />{" "}
                </PrivateRoute>
              }
            />
      
            <Route
              path="pendencies"
              element={
                <PrivateRoute>
                  {" "}
                  <Pendencies />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="generalRegistration"
              element={
                <RequiredProvider>
                  <PrivateRoute>
                    <GeneralRegistration />
                  </PrivateRoute>
                </RequiredProvider>
              }
            />
            <Route
              path="salesManagement"
              element={
                <PrivateRoute>
                  {" "}
                  <SalesManagement />{" "}
                </PrivateRoute>
              }
            />
            <Route path="enterprise/*" element={<EnterpriseRoutes />} />
            <Route
              path="enterpriseSettings/*"
              element={<EnterpriseSettingsRoute />}
            />
            <Route
              path="enterpriseDetails/:id"
              element={
                <PrivateRoute>
                  {" "}
                  <EnterpriseDetails />{" "}
                </PrivateRoute>
              }
            />
            <Route path="banks/*" element={<BanksRoute />} />
            <Route path="whatsappConfig/:id" element={<WhatsAppQRCode />} />
            <Route path="emailShippingDays/:id" element={<EmailConfig />} />
            <Route path="clickSignConfig/:id" element={<ClickSignConfig />} />
            <Route path="feasibilityStudy/:id" element={<FeasibilityStudy />} />
            <Route
              path="/negotiations/:id"
              element={
                <FiltersProvider>
                  <PrivateRoute>
                    {" "}
                    <Negotiations />{" "}
                  </PrivateRoute>
                </FiltersProvider>
              }
            />
            <Route
              path="/salesMirror/:id"
              element={
                <PrivateRoute>
                  {" "}
                  <SalesMirror />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="/register/:id"
              element={
                <PrivateRoute>
                  {" "}
                  <Register />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="/simulation"
              element={
                <FiltersProvider>
                  <PrivateRoute>
                    {" "}
                    <Simulation />{" "}
                  </PrivateRoute>
                </FiltersProvider>
              }
            />
            <Route
              path="/proposal"
              element={
                <FiltersProvider>
                  <PrivateRoute>
                    {" "}
                    <Proposal />{" "}
                  </PrivateRoute>
                </FiltersProvider>
              }
            />
            <Route path="financial/*" element={<FinancialRoute />} />
            <Route
              path="/userRegistration"
              element={
                <UserRegistrationProvider>
                  <PrivateRoute>
                    {" "}
                    <UserRegistration />{" "}
                  </PrivateRoute>
                </UserRegistrationProvider>
              }
            />
            <Route path="reports/*" element={<ReportsRoute />} />
            <Route path="notifications/*" element={<NotificationsRoute />} />
            <Route path="settings/*" element={<SettingsRoute />} />
            <Route path="/createSendEmails" element={<SendingEmails />} />
            <Route
              path="/createClickSignIntegrate"
              element={<ClickSignRegistrations />}
            />
            <Route
              path="logs"
              element={
                <PrivateRoute>
                  {" "}
                  <Logs />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="teams/:id"
              element={
                <PrivateRoute>
                  {" "}
                  <Teams />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="myAccount"
              element={
                <RequiredProvider>
                  <PrivateRoute>
                    <MyAccount />
                  </PrivateRoute>
                </RequiredProvider>
              }
            />
            <Route path="newPassword/*" element={<NewPassword />} />
            <Route path="wallet/*" element={<WalletRoute />} />
            <Route path="modules/*" element={<ModuleRoute />} />
            <Route path="/*" element={<AIroutes />} />
            <Route path="template/*" element={<TemplateRoute />} />
            <Route
              path="crm/*"
              element={
                <RequiredProvider>
                  <MapProvider>
                    <CrmRoute />
                  </MapProvider>
                </RequiredProvider>
              }
            />
            <Route
              path="connections"
              element={
                <PrivateRoute>
                  <Connections />
                </PrivateRoute>
              }
            />
            <Route path="*" element={<Error404 />} />


          </Route>
        </Routes>
      </SimuladorProvider>
    </BrowserRouter>
  );
}

export default Router;
